import { Component, OnInit, inject } from '@angular/core';
import { UserFacade } from '@app/store/user';
import { ChatListFacade } from '@app/store/chat-list';
import { SidebarMobileService } from '../../modules/sidebar-mobile';

@Component({
    selector: 'app-header-mobile',
    templateUrl: './header-mobile.component.html',
    styleUrls: ['./header-mobile.component.scss'],
})
export class HeaderMobileComponent implements OnInit {
    private readonly userFacade = inject(UserFacade);
    private readonly sidebarMobileService = inject(SidebarMobileService);
    private readonly chatListFacade = inject(ChatListFacade);

    readonly verificationStatus$ = this.userFacade.verificationStatus$;
    readonly unreadMessagesCount$ = this.chatListFacade.unreadMessagesCount$;

    ngOnInit(): void {
        this.chatListFacade.getList();
    }

    toggleSidebar() {
        this.sidebarMobileService.toggle();
    }
}
